import React, {useEffect, useState} from 'react';
import createDocx from "../functions/generateDocx";
import { saveAs } from "file-saver";
import {
    MDBBtn,
    MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle,
    MDBPagination,
    MDBPaginationItem, MDBPaginationLink, MDBSwitch,
    MDBTable,
    MDBTableBody,
    MDBTableHead, MDBTooltip
} from "mdb-react-ui-kit";
import Axios from "axios";
import {
    additionalInvoiceServices,
    backendPathAccounting,
    ENTRIES_PER_PAGE_INVOICE,
    substractionalInvoiceServices
} from "../Constants";
import {matchesSearch} from "../functions/matchPerson";
import {Link, useNavigate} from "react-router-dom";
import {getPaginationNumbers} from "../functions/pagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faFileWord, faPen, faTrash, faPlus, faMinus} from "@fortawesome/free-solid-svg-icons";
import {formatToPrice} from "../functions/finances";
import {checkWritePermission} from "../functions/permissions";
import TopNavbar from "../components/Navbar";
import DatePicker, { registerLocale } from "react-datepicker";
import de from "date-fns/locale/de";
import Moment from "moment/moment";
import CreatableSelect from "react-select/creatable";


registerLocale("de", de);
Moment.locale('de');

function Invoices() {
    const navigate = useNavigate();

    const [templateFile, setTemplateFile] = useState(null);
    const [customerList, setCustomerList] = useState([]);
    const [filteredCustomersList, setFilteredCustomersList] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [startIndex, setStartIndex] = useState(0);
    const [numberOfCustomers, setNumberOfCustomers] = useState(0);
    const [pageNumbers, setPageNumbers] = useState([]);
    const [invoiceCreationPopupVisible, setInvoiceCreationPopupVisible] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [invoiceRowsList, setInvoiceRowsList] = useState([]);
    const [useAmount, setUseAmount] = useState(false);
    const [addRowDisabled, setAddRowDisabled] = useState(false);
    const [rowSubmitDisabled, setRowSubmitDisabled] = useState(true);
    const [editingRowVisible, setEditingRowVisible] = useState(false);
    const [selectedInvoiceService, setSelectedInvoiceService] = useState(null);
    const [newAmount, setNewAmount] = useState(null);
    const [newUnitPrice, setNewUnitPrice] = useState(null);
    const [newTotalPrice, setNewTotalPrice] = useState(null);
    const [invoiceCreationDate, setInvoiceCreationDate] = useState(new Date());
    const [additionalServiceType, setAdditionalServiceType] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getInvoiceCustomers = () => {
        Axios.get(backendPathAccounting+"customers-table.php").then((response) => {
            if (response.data) {
                if (response.data === "unauthorized") {
                    navigate("/login");
                } else {
                    setCustomerList(response.data);
                    setFilteredCustomersList(response.data.filter(value => matchesSearch(value, searchValue)));
                }
                console.log(response.data)
            }
        });
    };


    const downloadTemplate = async () => {
        try {
            const response = await fetch(backendPathAccounting+'get-docx-template.php', {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error('File download failed!');
            }

            const blob = await response.blob();
            console.log("file success");
            setTemplateFile(blob);

        } catch (error) {
            console.error('Error:', error);
        }
    };


    const generateInvoice = (firstname, lastname, street, houseNumber, zip, city, sepa, customerFirstName, customerLastname, basicPrice, rowList) => {
        firstname = firstname === null ? "" : firstname;
        lastname = lastname === null ? "" : lastname;
        street = street === null ? "" : street;
        houseNumber = houseNumber === null ? "" : houseNumber;
        zip = zip === null ? "" : zip;
        city = city === null ? "" : city;
        sepa = sepa === null ? "" : sepa;
        basicPrice = basicPrice === null ? "" : basicPrice;
        createDocx(templateFile, firstname, lastname, street, houseNumber, zip, city, sepa, basicPrice, rowList, calcTotalPrice(), invoiceCreationDate)
            .then(doc => {
                const blob = new Blob([doc]);
                saveAs(blob, `${Moment(invoiceCreationDate).format("YYYYMM")} ${customerLastname}, ${customerFirstName} Rechnung 24h.docx`);
            }
        )
    }

    const clickInvoiceGeneration = (customer) => {
        setSelectedCustomer(customer);
        setInvoiceCreationPopupVisible(true);
    }

    const toggleShow = () => setInvoiceCreationPopupVisible(!invoiceCreationPopupVisible);

    const checkRowSubmit = () => {
        console.log(newUnitPrice);

        const parsedAmount = newAmount === null ? NaN : newAmount;
        const parsedUnitPrice = newUnitPrice === null ? NaN : newUnitPrice;
        const parsedTotalPrice = newTotalPrice === null ? NaN : newTotalPrice;

        console.log(parsedTotalPrice, newTotalPrice);

        // check if positive, number, only two decimals
        const amountValid = !isNaN(parsedAmount) && parsedAmount > 0;
        const unitPriceValid = !isNaN(parsedUnitPrice) && parsedUnitPrice > 0 && Number.isInteger(parsedUnitPrice * 100);
        const totalPriceValid = !isNaN(parsedTotalPrice) && parsedTotalPrice > 0 && Number.isInteger(parsedTotalPrice * 100);

        console.log(parsedTotalPrice);
        console.log(totalPriceValid);

        const splitPriceTrue = useAmount && unitPriceValid && amountValid;
        const totalPriceTrue = !useAmount && totalPriceValid;

        if (selectedInvoiceService !== null && (splitPriceTrue || totalPriceTrue)) {
            setRowSubmitDisabled(false);
        } else {
            setRowSubmitDisabled(true);
        }
    }

    const submitRow = () => {
        // calc product
        let rowTotal = newTotalPrice;
        if (useAmount) {
            console.log("calc", newAmount * newUnitPrice)
            rowTotal = newAmount * newUnitPrice;
        }

        // add row to list
        const newRow = {service: selectedInvoiceService, amount: newAmount, unitPrice: newUnitPrice, totalPrice: rowTotal};
        setInvoiceRowsList(prevRows => [...prevRows, newRow]);

        // clear editing row
        setEditingRowVisible(false);
        setNewTotalPrice(null);
        setNewUnitPrice(null);
        setNewAmount(null);
        setSelectedInvoiceService(null);
        setAddRowDisabled(false);
        setUseAmount(false);
    }

    const deleteRow = (indexToDelete) => {
        setInvoiceRowsList(prevRows =>
            prevRows.filter((_, index) => index !== indexToDelete)
        );
    }

    const closeCreationWindow = () => {
        toggleShow();
        setEditingRowVisible(false);
        setNewTotalPrice(null);
        setNewUnitPrice(null);
        setNewAmount(null);
        setSelectedInvoiceService(null);
        setInvoiceRowsList([]);
        setAddRowDisabled(false);
        setUseAmount(false);
    }

    const calcTotalPrice = () => {
        let total = 0;

        if (selectedCustomer !== null) {
            total += Number(selectedCustomer["BasicPrice"]);
        }

        for (const row of invoiceRowsList) {
            if (row.service.additional) {
                total += row.totalPrice;
            } else {
                total -= row.totalPrice;
            }
        }

        return total;
    }

    useEffect(() => {
        console.log("effect 0");
        checkWritePermission(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        console.log("effect 1");
        downloadTemplate().then(r => console.log("file done"));
        getInvoiceCustomers();
    }, [writePermission]);

    useEffect(() => {
        console.log("effect 4");
        setNumberOfCustomers(filteredCustomersList.length);
    }, [filteredCustomersList]);

    useEffect(() => {
        console.log("effect 2");
        setPageNumbers(getPaginationNumbers(numberOfCustomers, ENTRIES_PER_PAGE_INVOICE));
    }, [numberOfCustomers]);

    useEffect(() => {
        console.log("effect 3 filter ", customerList);
        setFilteredCustomersList(customerList.filter(value => matchesSearch(value, searchValue)));
        setStartIndex(0);
    }, [searchValue]);

    useEffect(() => {
        console.log("effect 5");
        checkRowSubmit();
        console.log(invoiceRowsList);
    }, [newAmount, newTotalPrice, newUnitPrice, useAmount, selectedInvoiceService]);


    return (
        <>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
            <div className='main'>
                <div className="header-above-table d-flex align-items-center">
                    <h2>Rechnungen</h2>
                    <div className="search-btns">
                        <MDBInput label='Suche' type='text' onChange={(e) => setSearchValue(e.target.value)}/>
                    </div>
                </div>

                <MDBTable align='middle'>
                    <MDBTableHead className="table-head">
                        <tr className="underlined-header">
                            <th scope='col'>Kundenname</th>
                            <th scope='col'>Rechnungsempfänger</th>
                            <th scope='col'>mtl. Grundpreis</th>
                            <th scope='col'>Zahlungsart</th>
                            <th scope='col'></th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        <tr className="table-body">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        {filteredCustomersList
                            .slice(startIndex, startIndex + ENTRIES_PER_PAGE_INVOICE)
                            .map((val, key) => {
                                return (
                                    <tr key={key}>
                                        <td>{val["FirstName"] + " " + val["LastName"]}</td>
                                        <td>
                                            {(val["FirstNameInvoice"] ? val["FirstNameInvoice"] : "")
                                                + (val["LastNameInvoice"] ? " " + val["LastNameInvoice"] : "")
                                                + (val["FirstNameInvoice"] === null && val["LastNameInvoice"] === null ? "-" : "")}
                                        </td>
                                        <td>{val["BasicPrice"] ? formatToPrice(val["BasicPrice"]) : "-"}</td>
                                        <td>{Number(val["SEPA"]) ? "SEPA" : "Überweisung"}</td>
                                        <td style={{textAlign: "right"}}>
                                            <MDBTooltip tag='a' title="bearbeiten">
                                                <FontAwesomeIcon className='btn-icon trash-btn' icon={faPen} onClick={
                                                    () => {
                                                        navigate("/edit-customer-invoice/" + val["CustomerID"]);
                                                    }}/>
                                            </MDBTooltip>

                                            <MDBTooltip tag='a' title="Rechnung erstellen">
                                                <FontAwesomeIcon className='btn-icon trash-btn ms-4' icon={faFileWord}
                                                                 onClick={() => {
                                                                     clickInvoiceGeneration(val);
                                                                 }}/>
                                            </MDBTooltip>
                                        </td>
                                    </tr>
                                );
                            })}
                    </MDBTableBody>
                </MDBTable>


                <nav className="page-selection-aria">
                    <MDBPagination className='page-selection'>
                        <MDBPaginationItem disabled={startIndex <= 0}
                                           onClick={() => {
                                               if (startIndex >= ENTRIES_PER_PAGE_INVOICE) {
                                                   setStartIndex(startIndex - ENTRIES_PER_PAGE_INVOICE)
                                               }
                                           }}>
                            <MDBPaginationLink>Zurück</MDBPaginationLink>
                        </MDBPaginationItem>

                        {
                            pageNumbers.map((val, key) => {
                                if (val === -1) {
                                    return (
                                        <p className={"pt-1 ms-2 me-2 paging-dots"}>...</p>
                                    );
                                } else {
                                    return (
                                        <MDBPaginationItem key={key} onClick={() => {
                                            setStartIndex((val - 1) * ENTRIES_PER_PAGE_INVOICE);
                                        }}>
                                            <MDBPaginationLink>{val}</MDBPaginationLink>
                                        </MDBPaginationItem>
                                    );
                                }
                            })
                        }

                        <MDBPaginationItem
                            disabled={startIndex / ENTRIES_PER_PAGE_INVOICE >= Math.ceil(numberOfCustomers / ENTRIES_PER_PAGE_INVOICE) - 1}
                            onClick={() => {
                                if (startIndex / ENTRIES_PER_PAGE_INVOICE < Math.ceil(numberOfCustomers / ENTRIES_PER_PAGE_INVOICE) - 1) {
                                    setStartIndex(startIndex + ENTRIES_PER_PAGE_INVOICE)
                                }
                            }}>
                            <MDBPaginationLink>Weiter</MDBPaginationLink>
                        </MDBPaginationItem>
                    </MDBPagination>
                </nav>

                {/* invoice creation popup */}
                <MDBModal show={invoiceCreationPopupVisible} setShow={setInvoiceCreationPopupVisible} tabIndex="-1" staticBackdrop={true}>
                    <MDBModalDialog size='xl'>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>
                                    {selectedCustomer === null ? "" :
                                        "Rechnung für " + selectedCustomer["FirstName"] + " " + selectedCustomer["LastName"] + " erstellen"
                                    }
                                </MDBModalTitle>
                                <MDBBtn
                                    className="btn-close"
                                    color="none"
                                    onClick={closeCreationWindow}
                                ></MDBBtn>
                            </MDBModalHeader>

                            <MDBModalBody>
                                Erstellungsdatum:
                                <DatePicker className="date-input-1 ms-3" locale="de" selected={invoiceCreationDate} dateFormat='dd.MM.yyyy' onChange={date =>
                                    setInvoiceCreationDate(date)}
                                />

                                <p>Rechnungspunkte hinzufügen:</p>

                                <MDBTable align='middle'>
                                    <MDBTableHead>
                                        <tr className="underlined-header">
                                            <th scope='col'></th>
                                            {/* + or - */}
                                            <th scope='col'>Leistung</th>
                                            <th scope='col'>Menge</th>
                                            <th scope='col'>Einzelpreis</th>
                                            <th scope='col'></th>
                                            {/* switch */}
                                            <th scope='col'>Gesamtpreis</th>
                                            <th scope='col'></th>
                                            {/* delete */}
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        <tr>
                                            <td></td>
                                            <td>Rund um die Uhr Betreuung</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td></td>
                                            <td>{selectedCustomer === null ? "" : formatToPrice(selectedCustomer["BasicPrice"])}</td>
                                            <td></td>
                                        </tr>

                                        {
                                            invoiceRowsList
                                                .map((val, key) => {
                                                    return (
                                                        <tr key={key}>
                                                            <td style={{textAlign: "center"}}>{val.service.additional ? "+" : "-"}</td>
                                                            <td>{val.service.label}</td>
                                                            <td>{val.amount !== null ? val.amount.toString() : "-"}</td>
                                                            <td>{val.unitPrice !== null ? formatToPrice(val.unitPrice) : "-"}</td>
                                                            <td></td>
                                                            <td>{formatToPrice(val.totalPrice.toString())}</td>
                                                            <td>
                                                                <MDBTooltip tag='a' wrapperProps={{}} title="löschen">
                                                                    <FontAwesomeIcon className='btn-icon trash-btn'
                                                                                     icon={faTrash} onClick={
                                                                        () => {
                                                                            console.log("delete row", key);
                                                                            deleteRow(key);
                                                                        }}/>
                                                                </MDBTooltip>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                        }
                                        {
                                            !editingRowVisible ? null :
                                                <tr>
                                                    <td style={{textAlign: "center"}}>
                                                        <MDBTooltip tag='a' title="Typ wechseln">
                                                            <FontAwesomeIcon className='btn-icon trash-btn table-btn-icon'
                                                                             icon={additionalServiceType ? faPlus : faMinus}
                                                                             onClick={ () => {
                                                                                 setAdditionalServiceType(!additionalServiceType);
                                                                             }}/>
                                                        </MDBTooltip>
                                                    </td>
                                                    <td>
                                                        <CreatableSelect id="select1" crea placeholder={additionalServiceType ? 'Zuzüge...' : 'Abzüge...'}
                                                                         formatCreateLabel={(inputValue) => `Hinzufügen: "${inputValue}"`}
                                                                         options={additionalServiceType ? additionalInvoiceServices : substractionalInvoiceServices}
                                                                onChange={(event) => {
                                                                    console.log(event);
                                                                    if ("label" in event) {
                                                                        const newService = {label: event.label, additional: additionalServiceType, value: 100};
                                                                        setSelectedInvoiceService(newService);
                                                                    }
                                                                }}
                                                        />
                                                    </td>
                                                    <td>
                                                        {
                                                            useAmount ?
                                                                <MDBInput label='' type='text' onChange={(event) => {
                                                                    console.log(event.target.value);
                                                                    setNewAmount(parseFloat(event.target.value.replace(",", ".")));
                                                                }}/>
                                                                : "-"
                                                        }
                                                    </td>
                                                    <td>
                                                        {
                                                            useAmount ?
                                                                <MDBInput label='' type='text' onChange={(event) => {
                                                                    console.log(event.target.value);
                                                                    setNewUnitPrice(parseFloat(event.target.value.replace(",", ".")));
                                                                }}/>
                                                                : "-"
                                                        }
                                                    </td>
                                                    <td>
                                                        <MDBTooltip tag='a' wrapperProps={{}}
                                                                    title="Preiseingabe wechseln">
                                                            <MDBSwitch checked={!useAmount}
                                                                       onChange={(event) => {
                                                                           if (useAmount) {
                                                                               setNewUnitPrice(null);
                                                                               setNewAmount(null);
                                                                           } else {
                                                                               setNewTotalPrice(null);
                                                                           }
                                                                           setUseAmount(s => (s + 1) % 2);
                                                                       }
                                                                       }/>
                                                        </MDBTooltip>
                                                    </td>
                                                    <td>
                                                        {
                                                            !useAmount ?
                                                                <MDBInput label='' type='text' onChange={(event) => {
                                                                    console.log(event.target.value);
                                                                    setNewTotalPrice(parseFloat(event.target.value.replace(",", ".")));
                                                                }}/>
                                                                : ""
                                                        }
                                                    </td>
                                                    <td>
                                                        <MDBBtn className="btn" disabled={rowSubmitDisabled}
                                                                onClick={() => {
                                                                    submitRow();
                                                                }}>
                                                            <FontAwesomeIcon className='btn-icon' size="lg"
                                                                             icon={faCheck}/>
                                                        </MDBBtn>
                                                    </td>
                                                </tr>
                                        }
                                    </MDBTableBody>
                                </MDBTable>

                                <div style={{textAlign: "center"}}>
                                    <MDBBtn className="addRowBtn" disabled={addRowDisabled} onClick={() => {
                                        setEditingRowVisible(true);
                                        setAddRowDisabled(true);
                                    }}> Zeile hinzufügen </MDBBtn>
                                </div>

                                <p>{"Gesamtpreis: " + formatToPrice(calcTotalPrice().toString())}</p>

                            </MDBModalBody>

                            <MDBModalFooter>
                                <MDBBtn className="btn-light" onClick={closeCreationWindow}>
                                    Abbrechen
                                </MDBBtn>
                                <MDBBtn onClick={() => {
                                    generateInvoice(selectedCustomer["FirstNameInvoice"], selectedCustomer["LastNameInvoice"],
                                        selectedCustomer["StreetInvoice"], selectedCustomer["HouseNumberInvoice"], selectedCustomer["ZIPInvoice"],
                                        selectedCustomer["CityInvoice"], Number(selectedCustomer["SEPA"]), selectedCustomer["FirstName"],
                                        selectedCustomer["LastName"], selectedCustomer["BasicPrice"], invoiceRowsList);
                                }}>Erstellen</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
            </div>
        </>

    );
}

export default Invoices;